import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import IndicatorsView from '../views/IndicatorsView.vue'
import TechShareView from '../views/TechShareView.vue'
import ForumView from '../views/ForumView.vue'
import UserCenterView from '../views/UserCenterView.vue'
import AlipayDemoView from '../views/AlipayDemoView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/indicators',
    name: 'indicators',
    component: IndicatorsView
  },
  {
    path: '/tech-share',
    name: 'tech-share',
    component: TechShareView
  },
  {
    path: '/forum',
    name: 'forum',
    component: ForumView
  },
  {
    path: '/user',
    name: 'user',
    component: UserCenterView
  },
  {
    path: '/post/:id',
    name: 'post',
    component: () => import('../views/PostDetailView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue')
  },
  {
    path: '/alipay-demo',
    name: 'alipay-demo',
    component: AlipayDemoView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router